import { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import OrderModalBlock from "../Modals/OrderModal/OrderModalBlock"
import styles from "../Modals/OrderModal/OrderModal.module.scss"

interface Props {
  id: string
  title: string
  formula: string
  options: {
    id: string
    name: string
  }[]
}

const OrderOptionFormula = ({ id, title, formula, options }: Props) => {
  const { values, setFieldValue } = useFormikContext<{ [key: string]: any }>()
  const [formulaOutput, setFormulaOutput] = useState<string | number | null>(null)

  useEffect(() => {
    let parsedFormula = formula
    let isFormulaReady = true
    options.forEach((o) => {
      const val = !values[o.id] && values[o.id] !== 0 ? null : values[o.id]
      if (!values[o.id] && values[o.id] !== 0 && values[o.id] !== "0") {
        isFormulaReady = false
        return
      }
      const replacedString = "$options['" + o.name + "']"
      parsedFormula = parsedFormula.replaceAll(replacedString, val)
    })

    if (!isFormulaReady) {
      setFormulaOutput(null)
      setFieldValue(id, null)
      return
    }

    try {
      const output = new Function("return " + parsedFormula)()
      setFormulaOutput(output)
      setFieldValue(id, output)
    } catch (err) {
      console.error("error in new Function formula: ", err)
      setFormulaOutput(null)
      setFieldValue(id, null)
    }
  }, [formula, values, options])

  return (
    <OrderModalBlock title={title}>
      <input
        type={"text"}
        value={formulaOutput || ""}
        name={"option-input-formula"}
        className={styles.formulaInput}
        readOnly
      />
    </OrderModalBlock>
  )
}

export default OrderOptionFormula
